export enum Roles {
  Superadmin = 'SUPERADMIN',
  User = 'USER',
  Vcm = 'VCM',
  Pm = 'PM',
  PM_FREE = 'PM_FREE',
  Resident = 'RESIDENT',
  PM = 'PM'
}
